/**
 * @generated SignedSource<<44674db683a9dc0ad8ca4040dccd1a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MoveProjectOnTimelineInput = {
  id?: string | null;
  projectStartYear?: number | null;
  projectStartMonth?: number | null;
  projectStartDay?: number | null;
  projectEndYear?: number | null;
  projectEndMonth?: number | null;
  projectEndDay?: number | null;
  isWeekendHidden?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type moveProjectOnTimelineMutation$variables = {
  input: MoveProjectOnTimelineInput;
};
export type moveProjectOnTimelineMutation$data = {
  readonly moveProjectOnTimeline: {
    readonly project: {
      readonly id: string;
      readonly projectStartYear: number | null;
      readonly projectStartMonth: number | null;
      readonly projectStartDay: number | null;
      readonly projectEndYear: number | null;
      readonly projectEndMonth: number | null;
      readonly projectEndDay: number | null;
    } | null;
  } | null;
};
export type moveProjectOnTimelineMutation = {
  variables: moveProjectOnTimelineMutation$variables;
  response: moveProjectOnTimelineMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoveProjectOnTimelinePayload",
    "kind": "LinkedField",
    "name": "moveProjectOnTimeline",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectStartYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectStartMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectStartDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectEndYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectEndMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectEndDay",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveProjectOnTimelineMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moveProjectOnTimelineMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e272f7462df937fe7a66cce7dd1e1b70",
    "id": null,
    "metadata": {},
    "name": "moveProjectOnTimelineMutation",
    "operationKind": "mutation",
    "text": "mutation moveProjectOnTimelineMutation(\n  $input: MoveProjectOnTimelineInput!\n) {\n  moveProjectOnTimeline(input: $input) {\n    project {\n      id\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "109afb9720c922397ad4e2a1ea681ff6";

export default node;
